module.exports = __webpack_public_path__ + "img/ng.520463e1.svg";